module.exports = __webpack_public_path__ + "img/ph.4e44ea6.svg";